import { render, staticRenderFns } from "./special-business.vue?vue&type=template&id=6da94d18"
import script from "./special-business.vue?vue&type=script&lang=js"
export * from "./special-business.vue?vue&type=script&lang=js"
import style0 from "./special-business.vue?vue&type=style&index=0&id=6da94d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports